import { connect } from 'react-redux'
import { getApper, postQingjiafileEditor } from './actions'
import Setting from './main'


const mapDispatchToProps = {
  getApper,
    postQingjiafileEditor
}
const mapStateToProps = (state) => {
  return {
    ...state.QingjiaFileEditor
  }
}
  

export default connect(mapStateToProps, mapDispatchToProps)(Setting)
